// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { writeQueryInterop } from '@confluence/apollo-relay-interop/entry-points/writeQuery.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import CustomHeaderFooterQuery, {
	type CustomHeaderFooterQuery$data,
	type CustomHeaderFooterQuery$variables,
} from './__generated__/CustomHeaderFooterQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const primeCustomHeaderAndFooterFromRouteData = (
	spaceKey: string,
	data: CustomHeaderFooterQuery$data | null | undefined,
): void => {
	const cacheData: CustomHeaderFooterQuery$data = {
		space: data?.space
			? {
					id: data.space.id,
					settings: data.space.settings
						? {
								customHeaderAndFooter: data.space.settings.customHeaderAndFooter,
							}
						: null,
				}
			: null,
	};

	writeQueryInterop<CustomHeaderFooterQuery$data, CustomHeaderFooterQuery$variables>({
		query: CustomHeaderFooterQuery,
		variables: { spaceKey },
		data: cacheData,
	});
};

export function preloadCustomHeaderAndFooter(spaceKey: any): Promise<{
	data: CustomHeaderFooterQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<CustomHeaderFooterQuery$data, CustomHeaderFooterQuery$variables>({
		query: CustomHeaderFooterQuery,
		variables: {
			spaceKey,
		},
	});
}
